import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29961ed3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-width w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", { span: "5" }, null, -1))
const _hoisted_5 = { class: "bg-primary text-color-white py-9" }
const _hoisted_6 = {
  colspan: "5",
  scope: "colgroup"
}
const _hoisted_7 = { style: {"font-weight":"600"} }
const _hoisted_8 = {
  class: "align-text-left",
  style: {"width":"22%"}
}
const _hoisted_9 = {
  class: "align-text-right",
  style: {"width":"17%"}
}
const _hoisted_10 = {
  class: "align-text-right",
  style: {"width":"17%"}
}
const _hoisted_11 = {
  class: "align-text-right",
  style: {"width":"22%"}
}
const _hoisted_12 = { class: "align-text-left" }
const _hoisted_13 = {
  key: 0,
  class: "small-text"
}
const _hoisted_14 = { class: "align-text-right" }
const _hoisted_15 = { class: "align-text-right" }
const _hoisted_16 = { class: "align-text-right" }
const _hoisted_17 = {
  style: {"font-weight":"600"},
  class: "bg-primary text-color-white"
}
const _hoisted_18 = { class: "align-text-left" }
const _hoisted_19 = { class: "small-text" }
const _hoisted_20 = { class: "align-text-right" }
const _hoisted_21 = { class: "align-text-right" }
const _hoisted_22 = { class: "align-text-right" }
const _hoisted_23 = { style: {"font-weight":"600"} }
const _hoisted_24 = { class: "align-text-left" }
const _hoisted_25 = { class: "small-text" }
const _hoisted_26 = { class: "align-text-right" }
const _hoisted_27 = { class: "align-text-right" }
const _hoisted_28 = { class: "align-text-right" }
const _hoisted_29 = ["aria-label"]
const _hoisted_30 = { class: "full-width w-100" }
const _hoisted_31 = {
  key: 1,
  class: "row mt-605"
}
const _hoisted_32 = {
  key: 2,
  class: "row mt-605 print-break-before"
}
const _hoisted_33 = { class: "full-width w-100" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = ["aria-label"]
const _hoisted_36 = { class: "bg-primary text-color-white py-9" }
const _hoisted_37 = {
  scope: "col",
  style: {"border-right":"none"}
}
const _hoisted_38 = { class: "small-text" }
const _hoisted_39 = {
  scope: "col",
  class: "align-text-right"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { style: {"width":"55%"} }
const _hoisted_42 = {
  class: "align-text-right",
  style: {"width":"45%"}
}
const _hoisted_43 = { class: "align-text-right" }
const _hoisted_44 = { class: "align-text-right" }
const _hoisted_45 = {
  key: 3,
  id: "text-area-description",
  class: "full-width w-100"
}
const _hoisted_46 = {
  key: 4,
  class: "full-width w-100 preserve-linebreaks print-remarks-container"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  id: "submitButton",
  class: "button button-primary mt-5",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_PieChart = _resolveComponent("PieChart")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, [
      _createVNode(_component_SimpleText, {
        "text-key": "calculation.mainresult.text.mainresult",
        "aria-live": "polite"
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
      [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.mainresult.description')]
    ]),
    _hoisted_2,
    (_ctx.results?.groupingResults)
      ? (_openBlock(), _createElementBlock("table", {
          key: 0,
          "aria-label": _ctx.getContentfulString('calculation.mainresult.text.mainresult'),
          class: "table results-table w-percent-100"
        }, [
          _hoisted_4,
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_5, [
              _withDirectives(_createElementVNode("th", _hoisted_6, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.mainresult.table1.title')]
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_7, [
              _withDirectives(_createElementVNode("td", _hoisted_8, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.mainresult.table1.maincategory')]
              ]),
              _withDirectives(_createElementVNode("td", _hoisted_9, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.mainresult.table1.emission-scope1-3')]
              ]),
              _withDirectives(_createElementVNode("td", _hoisted_10, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.mainresult.table1.share-emission-scope1-3')]
              ]),
              _withDirectives(_createElementVNode("td", _hoisted_11, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.mainresult.table1.emission-outsidescope')]
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.groupingResults, (result) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: result.groupingName
              }, [
                _createElementVNode("td", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.publicCategoryTheme(result.groupingName)) + " ", 1),
                  (_ctx.shouldDisplayElectricityMethodForGrouping(result))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(" + _toDisplayString(this.electricityCalculationMethodText(_ctx.results.electricityEnvironmentDeclaration)) + ")", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.doPrettify(result.calculatedResult?.scopesResult || 0, 2)), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(result.calculatedResult?.scopesResult && _ctx.results?.scoresTotalResult
            ? _ctx.doPrettify(((result.calculatedResult?.scopesResult / _ctx.results.scoresTotalResult) * 100))
            : _ctx.doPrettify(0, 2)) + "%", 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.doPrettify(result.calculatedResult?.outsideScopeResult || 0 , 2)), 1)
              ]))
            }), 128)),
            _createElementVNode("tr", _hoisted_17, [
              _createElementVNode("td", _hoisted_18, [
                _createVNode(_component_SimpleText, { "text-key": "shared.text.total" }),
                _createTextVNode(),
                _createElementVNode("span", _hoisted_19, "(" + _toDisplayString(this.electricityCalculationMethodText(_ctx.results.electricityEnvironmentDeclaration)) + ")", 1)
              ]),
              _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.doPrettify(_ctx.results.scoresTotalResult || 0, 2)), 1),
              _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.doPrettify(100, 2)) + "%", 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.doPrettify(_ctx.results.outsideScoresTotalResult || 0, 2)), 1)
            ]),
            _createElementVNode("tr", _hoisted_23, [
              _createElementVNode("td", _hoisted_24, [
                _createVNode(_component_SimpleText, { "text-key": "shared.text.total" }),
                _createTextVNode(),
                _createElementVNode("span", _hoisted_25, "(" + _toDisplayString(this.electricityCalculationMethodText(!_ctx.results.electricityEnvironmentDeclaration)) + ")", 1)
              ]),
              _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.doPrettify(_ctx.results.scoresTotalResultOtherDeclaration || 0, 2)), 1),
              _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.doPrettify(100, 2)) + "%", 1),
              _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.doPrettify(_ctx.results.outsideScoresTotalResultOtherDeclaration || 0, 2)), 1)
            ])
          ])
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("h2", {
      "aria-live": "polite",
      "aria-label": _ctx.getContentfulString('calculation.mainresult.text.summary') || _ctx.missingContent
    }, [
      _createTextVNode(_toDisplayString(_ctx.getContentfulString('calculation.mainresult.text.summary') || _ctx.missingContent), 1)
    ], 8, _hoisted_29)), [
      [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.summary') || _ctx.missingContent]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_30, null, 512), [
      [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.summary.description')]
    ]),
    (_ctx.results?.groupingResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.printMode ? 'col-12' : 'col-6')
          }, [
            _createVNode(_component_BarChart, {
              printMode: _ctx.printMode,
              results: _ctx.results,
              showOnlyScopes: true,
              title: _ctx.getContentfulString('calculation.mainresult.text.figure1')
            }, null, 8, ["printMode", "results", "title"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.printMode ? 'col-12 mt-605' : 'col-6')
          }, [
            _createVNode(_component_PieChart, {
              negativeResultHeader: _ctx.getContentfulString('calculation.mainresult.text.negative-result-messageheader'),
              negativeResultText: _ctx.getContentfulString('calculation.mainresult.text.negative-result-messagetext'),
              printMode: _ctx.printMode,
              results: _ctx.results,
              showOnlyScopes: true,
              title: _ctx.getContentfulString('calculation.mainresult.text.figure2')
            }, null, 8, ["negativeResultHeader", "negativeResultText", "printMode", "results", "title"])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.results?.groupingResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.printMode ? 'col-12' : 'col-6')
          }, [
            _createVNode(_component_BarChart, {
              printMode: _ctx.printMode,
              results: _ctx.results,
              showOnlyOutsideScopes: true,
              title: _ctx.getContentfulString('calculation.mainresult.text.figure3')
            }, null, 8, ["printMode", "results", "title"])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h2", null, [
      _createVNode(_component_SimpleText, {
        "text-key": "calculation.mainresult.text.keynumbers",
        "aria-live": "polite"
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_33, null, 512), [
      [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.keynumbers.description') || _ctx.missingContent]
    ]),
    _hoisted_34,
    _createElementVNode("table", {
      "aria-label": _ctx.getContentfulString('calculation.mainresult.text.keynumbers'),
      class: "table",
      style: {"width":"555px"}
    }, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_36, [
          _createElementVNode("th", _hoisted_37, [
            _createVNode(_component_SimpleText, { "text-key": "calculation.mainresult.text.keynumbers.calculations" }),
            _createTextVNode(),
            _createElementVNode("span", _hoisted_38, "(" + _toDisplayString(this.electricityCalculationMethodText(_ctx.results.electricityEnvironmentDeclaration)) + ")", 1)
          ]),
          _withDirectives(_createElementVNode("th", _hoisted_39, null, 512), [
            [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.keynumbers.co2')]
          ])
        ])
      ]),
      (_ctx.results)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_40, [
            _createElementVNode("tr", {
              class: _normalizeClass({ 'missing-data': !_ctx.results.resultOnNumberOfEmployees })
            }, [
              _withDirectives(_createElementVNode("td", _hoisted_41, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.keynumbers.co2-per-employee')]
              ]),
              _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.doPrettify(_ctx.results.resultOnNumberOfEmployees, 2) || _ctx.getContentfulString('calculation.mainresult.text.no-master-data')), 1)
            ], 2),
            _createElementVNode("tr", {
              class: _normalizeClass({ 'missing-data': !_ctx.results.resultOnTurnover })
            }, [
              _withDirectives(_createElementVNode("td", null, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.keynumbers.co2-per-turnover')]
              ]),
              _withDirectives(_createElementVNode("td", _hoisted_43, null, 512), [
                [_directive_dompurify_html, _ctx.doPrettify(_ctx.results.resultOnTurnover, 2) || _ctx.getContentfulString('calculation.mainresult.text.no-master-data')]
              ])
            ], 2),
            _createElementVNode("tr", {
              class: _normalizeClass({ 'missing-data': !_ctx.results.resultOnNumberOfSquareMeters })
            }, [
              _withDirectives(_createElementVNode("td", null, null, 512), [
                [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.keynumbers.co2-per-area')]
              ]),
              _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.doPrettify(_ctx.results.resultOnNumberOfSquareMeters, 2) || _ctx.getContentfulString('calculation.mainresult.text.no-master-data')), 1)
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_35),
    _createElementVNode("h2", null, [
      _createVNode(_component_SimpleText, {
        "text-key": "calculation.mainresult.text.own-notes",
        "aria-live": "polite"
      })
    ]),
    (!_ctx.printMode)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_45, null, 512)), [
          [_directive_dompurify_html, _ctx.getContentfulString('calculation.mainresult.text.own-notes.description')]
        ])
      : _createCommentVNode("", true),
    (_ctx.printMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.calculation.resultComment), 1))
      : _createCommentVNode("", true),
    (!_ctx.printMode)
      ? (_openBlock(), _createElementBlock("form", {
          key: 5,
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitComment && _ctx.submitComment(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("textarea", {
              id: "input-area",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
              disabled: this.calculation.state !== 'draft' && this.calculation.state !== 'duplicated',
              "aria-labelledby": "text-area-description",
              class: "form-input",
              maxlength: "500",
              name: "input-area",
              rows: "5",
              style: {"max-width":"555px"}
            }, null, 8, _hoisted_47), [
              [_vModelText, _ctx.comment]
            ])
          ]),
          _createElementVNode("button", _hoisted_48, [
            _createVNode(_component_SimpleText, { "text-key": "sharedContent.save" })
          ])
        ], 32))
      : _createCommentVNode("", true)
  ], 64))
}